import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserVehicleForm } from "Bands/components";
import { editUserVehicle, userVehicleSelectorCreator } from "Bands/state";
import { IUserVehiclePatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Car } from "shared/assets/icons";

const { userVehicle: vehicleCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserVehicleModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const vehicleIdSelector = useMemo(() => userVehicleSelectorCreator(id), [id]);
  const vehicle = useSelector(vehicleIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserVehiclePatchData) => {
    dispatch(editUserVehicle({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={vehicle}
      title={vehicleCopy.edit.title}
      icon={Car}
      action={USER_ACTIONS.editUserVehicle}
      buttons={buttons}
      successMessage={vehicleCopy.messages.edited}
      Component={UserVehicleForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
